import type { NotificacaoTesteCanal } from "@/services/api/notificacao-teste.service";

// Aceita um destinatário por linha, vírgula ou ponto-e-vírgula.
export function parseDestinatarios(raw: string): string[] {
  return raw
    .split(/[\n,;]+/)
    .map((d) => d.trim())
    .filter(Boolean);
}

export const isEmailValido = (e: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);
// WhatsApp (Whapi) e SMS esperam só dígitos com DDI+DDD. Ex.: 5511999999999 (12–13 no BR; 15 é o máx. E.164).
export const normalizarTelefone = (t: string) => t.replace(/\D/g, "");
export const isTelefoneValido = (t: string) => {
  const d = normalizarTelefone(t);
  return d.length >= 12 && d.length <= 15;
};

/**
 * Endereços digitados, separados em válidos (já normalizados) e inválidos (originais).
 * Não vale para o INBOX: lá o endereço é o `identityId`, escolhido numa lista.
 */
export function validarDestinatarios(lista: string[], canal: NotificacaoTesteCanal) {
  const validos: string[] = [];
  const invalidos: string[] = [];
  for (const d of lista) {
    if (canal === "EMAIL") {
      (isEmailValido(d) ? validos : invalidos).push(d);
    } else if (isTelefoneValido(d)) {
      validos.push(normalizarTelefone(d));
    } else {
      invalidos.push(d);
    }
  }
  return { validos, invalidos };
}

export const ASSUNTO_PADRAO = "Notificação de teste";

export const CORPO_PADRAO: Record<NotificacaoTesteCanal, string> = {
  EMAIL: "<p>Olá! Esta é uma notificação de teste enviada pelo Workflow.</p>",
  WHATSAPP: "Olá! Esta é uma notificação de teste enviada pelo Workflow.",
  // Curto de propósito: SMS é cobrado a cada 160 caracteres (70 com acento/emoji).
  SMS: "Teste de SMS do Workflow.",
  INBOX: "Olá! Esta é uma **notificação de teste** enviada pelo Workflow.",
};

// Considera "não editado" quando vazio ou igual a algum padrão — só então troca ao mudar de canal.
export const CORPOS_PADRAO = Object.values(CORPO_PADRAO);
